<template>

    <div class="result-page-nav">
        <div>
            <img src="../nav/img/logo.png" alt="" class="logo cur" @click="logo">
            <img src="../../assets/images/3.png" alt="" class="corner-mark3">
        </div>
        <!--  class="result-sch" -->
        <div class="result-sch" v-if="chartsVue">
            <div class="ipt-box certain-category-search-wrapper">
                <!-- :data-source="dataSourceHint" -->
                <a-auto-complete ref="autoComplete"
                    class="certain-category-search"
                    dropdown-class-name="certain-category-search-dropdown"
                    :dropdown-match-select-width="false"
                    :filter-option="filterOption"
                    v-model="simpleKeyword"
                    option-label-prop="value"
                    @focus="onFocus"
                    @search="onAutoSearch"
                >
                    <template slot="dataSource">
                        <a-select-opt-group v-for="group in dataSourceHint" :key="group.title">
                            <span slot="label">{{ group.title }}</span>
                            <a-select-option v-for="opt in group.children" :key="opt" :value="opt">
                                {{ opt }}
                            </a-select-option>
                        </a-select-opt-group>
                    </template>
                    <!-- <input type="text" @change="change"> v-model="simpleKeyword" -->
                    <input type="text" @keyup.enter="simpleSearch2" @input="changeInput">
                </a-auto-complete>

                <!-- 相机图标 -->
                <!-- <a-icon style="color: #fff;font-size: 18px;cursor: pointer" type="camera" /> --> 
                <!-- <a-divider style="background: #f0be73;" type="vertical" /> -->
                <a-icon style="color: #fff;font-size: 18px;cursor: pointer;margin-right: 20px" type="search" @click="simpleSearch2"/>

                <div class="advanced-search">
                    <a href="javascript:" class="more-search" @click="showSearch">
                        <span>高级</span><br>
                        <span>搜索</span>
                    </a>
                </div>
                <div class="search-box">
                    <searchTab 
                        :visible="visible"
                        :navKnowledge="navKnowledge"
                        :navAdvanced="navAdvanced"
                        :isResultSearch="isResultSearch"
                        @hideSearch="hideSearch" 
                        @getTabIndex="getTabIndex" 
                        @advancedSearch2="advancedSearch2"
                        @knowledgeChange="knowledgeChange"
                        @professSearch2="professSearch2"
                    />
                </div>
            </div>
            <!--  class="filters" -->
            <div :class="tabContentIndex===1 ? 'filters cur' : 'filters'">
                <div style="margin-right: 10px;">所有筛选 <a-icon style="color: #f0be73;" type="right" /></div>
                <!-- <span ref="filter1">条件 <a-icon type="close" style="color: #f0be73;cursor: pointer" @click="removeFilter(1)"/></span>
                <span ref="filter2">条件 <a-icon type="close" style="color: #f0be73;cursor: pointer" @click="removeFilter(2)"/></span> -->
                <span :ref="'filter'+index" v-for="(item, index) in activeFilterParams" :key="index">
                    {{item.field ? toFullTitle(item.field)+': ' : ''}}{{item.value}}
                    <a-icon type="close" style="color: #f0be73;cursor: pointer" @click="removeFilter(index)"/>
                </span>
            </div>
        </div>
        <div :class="slideShow?'navs hd':'navs'">
            <a href="javascript:;" class="nv" @click="navKnowledgeSearch">知识检索</a>
            <a href="https://dhc.library.sh.cn/humanmap/" target="_blank" class="nv">人文地图</a>
            <a href="javascript:;" class="nv"
                @click="onRelation('http://data.library.sh.cn/entity/person/4lnpsgh342b2n1ru', null)"
            >关系图谱</a>
            <!-- <router-link to="/" class="nv">故事场景</router-link> -->
            <a-dropdown placement="bottomLeft">
                <!-- <a-button>故事场景</a-button> -->
                <a href="javascript:;" class="nv">故事场景</a>
                <template v-slot:overlay>
                    <a-menu>
                        <a-menu-item>
                            <a rel="noopener noreferrer" href="javascript:;"
                                @click="onRelation('http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc', 'bk')"
                            >报人关系</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/bk/brandHome"
                            >海派品牌</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/newspapermap/"
                            >报馆地图</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/redtrip/index.html"
                            >红色旅游</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="http://wkl.library.sh.cn/"
                            >从武康路出发</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://ldy.library.sh.cn/"
                            >电影记忆</a>
                        </a-menu-item>
                        <!--20231128 高德水印问题 chenss <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/familytree/"
                            >家谱迁徙图</a>
                        </a-menu-item> -->
                    </a-menu>
                </template>
            </a-dropdown>
            <span class="nv" v-if="!userInfo" >
                <a :href="Common.registerUrl">注册</a>/<a href="javascript:;" @click="login">登录</a>
            </span>
            <span class="nv" v-else>
               <a href="javascript:;" @click="goDhcUc">
                   <img class="user" src="/user2.png">{{Common.userInfo.userName}}
                </a> |
               <a href="javascript:;" @click="exit">退出</a>
            </span>
            <a href="javascript:" :class="slideShow?'menu-toggle cur':'menu-toggle'" @click="showSlide">
                <span></span>
                <span></span>
                <span></span>
            </a>
        </div>
        <div :class="slideShow?'menu-slide-box cur':'menu-slide-box'">
            <div class="s-logo">
                <img src="../../assets/images/3.png" alt="" class="corner-mark2">
            </div>
            <div class="links">
                <div class="link-row">
                    <div class="title">
                        文<br/>献<br/>知<br/>识<br/>库
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions">
                                <swiper-slide v-for="f in Math.ceil(swiperData1.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData1.length/3))?(swiperData1.length%3===0?3:swiperData1.length%3):3)"
                                       :href="swiperData1[(f-1)*3+item-1].url" :key="item" target="_blank"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData1[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData1[(f-1)*3+item-1].name}}</span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData1.length > 3">
                            <a-icon type="left" class="prev1" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next1" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row">
                    <div class="title">
                        基<br/>础<br/>知<br/>识<br/>库
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions2">
                                <swiper-slide v-for="f in Math.ceil(swiperData2.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData2.length/3))?(swiperData2.length%3===0?3:swiperData2.length%3):3)"
                                       :href="swiperData2[(f-1)*3+item-1].url" :key="item" target="_blank"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData2[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData2[(f-1)*3+item-1].name}}</span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData2.length > 3">
                            <a-icon type="left" class="prev2" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next2" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row">
                    <div class="title">
                        本<br/>体<br/>词<br/>表
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions3">
                                <swiper-slide v-for="f in Math.ceil(swiperData3.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData3.length/3))?(swiperData3.length%3===0?3:swiperData3.length%3):3)"
                                       :href="swiperData3[(f-1)*3+item-1].url" :key="item" target="_blank"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData3[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData3[(f-1)*3+item-1].name}}</span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData3.length > 3">
                            <a-icon type="left" class="prev3" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next3" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row">
                    <div class="title">
                        工<br/>具
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions4">
                                <swiper-slide v-for="f in Math.ceil(swiperData4.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData4.length/3))?(swiperData4.length%3===0?3:swiperData4.length%3):3)"
                                       :href="swiperData4[(f-1)*3+item-1].url" :key="item" target="_blank"
                                       :style="swiperData4.length <= 3 ? 'width: 27%;' : ''"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData4[(f-1)*3+item-1])" @mouseleave="handleLeave" v-html="swiperData4[(f-1)*3+item-1].name"></span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData4.length > 3">
                            <a-icon type="left" class="prev4" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next4" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row"></div>
                <div class="link-row">
                    <div class="title">
                        其<br/>他<br/>文<br/>献
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions5" ref="mySwiper5">
                                <swiper-slide v-for="f in Math.ceil(swiperData5.length/3)" :key="f">
                                    <a v-for="(item,index) in (f===(Math.ceil(swiperData5.length/3))?(swiperData5.length%3===0?3:swiperData5.length%3):3)"
                                       :href="swiperData5[(f-1)*3+item-1].url" :key="'mySwiper5'+index" target="_blank"
                                       :style="swiperData5.length <= 3 ? 'width: 27%;' : ''"
                                    >
                                        <span v-if="!swiperData5[(f-1)*3+item-1].hoverEng" 
                                            v-html="swiperData5[(f-1)*3+item-1].name"
                                        ></span>
                                        <span v-else 
                                            @mouseenter="handleHover($event,swiperData5[(f-1)*3+item-1])" 
                                            @mouseleave="handleLeave" v-html="swiperData5[(f-1)*3+item-1].name"
                                        ></span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData5.length > 3">
                            <a-icon type="left" class="prev5" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next5" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hover-tips" v-if="showHover && hoverTit" :style="'left:'+hoverX+'px;top:'+hoverY+'px'">
            <div class="tit">{{hoverTit}}</div>
            <p>{{hoverEng}}</p>
        </div>
    </div>
</template>

<script>
    import searchTab from "../searchTab/index";
    import $ from 'jquery'
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        props: {
            chartsVue:{
                default:true
            },
            isResultSearch:{ // 是否列表页检索（result）
                default:false
            },
        },
        components: {
            searchTab,
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        computed:{
            activeFilterParams: function(){
                return this.filterParams.filter(function(item) {
                    return item.value
                })
            },
            activeUserInfo(){
                return this.Common.userInfo;
            }
        },
        data(){
            return{
                dataSourceHint: [], // 检索框提示
                logo1: '/pic/etl.png',
                tips: "/pic/tips.png",
                gjLog: "/pic/logo4.png",
                slideShow:false,
                navKnowledge: 0,   // 导航栏知识检索按钮
                navAdvanced : 0,   // 高级检索按钮
                simpleKeyword: '', // 简单检索值
                advancedParams: '',// 高级检索时，传递的所有值
                professKeyword: '',// 专业检索值
                filterParams: [],  // 筛选条件内容
                userInfo: null,    // 用户信息
                tabContentIndex: 0,
                childTabIndex: 0,
                result: 0, // 向book组件传值
                visible: false,
                searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
                showHover:false,
                hoverTit:'',
                hoverEng:'',
                hoverX:'',
                hoverY:'',
                swiperOptions:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next1',
                        prevEl: '.prev1',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions2:{
                    slidesPerView: 'auto',
                    spaceBetween: 2, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next2',
                        prevEl: '.prev2',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions3:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next3',
                        prevEl: '.prev3',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions4:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next4',
                        prevEl: '.prev4',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions5:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next5',
                        prevEl: '.prev5',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperData1:[
                    {
                        name:'家谱',
                        id:'1',
                        hoverTit:'中国家谱知识服务平台',
                        hoverEng:'Chinese Genealogy Knowledge Service Platform',
                        url:'//jiapu.library.sh.cn'
                    },
                    {
                        name:'盛档',
                        id:'2',
                        hoverTit:'盛宣怀档案知识库',
                        hoverEng:'Sheng Xuanhuai Archives Knowledge Base',
                        url:'//sd.library.sh.cn'
                    },
                    {
                        name:'古籍',
                        id:'3',
                        hoverTit:'中文古籍联合目录及循证平台',
                        hoverEng:'Chinese Ancient Books Union Catalogue and Evidence-based Platform',
                        url:'//gj.library.sh.cn'
                    },
                    {
                        name:'红色文献',
                        id:'4',
                        hoverTit:'革命（红色）文献服务平台',
                        hoverEng:'Revolutionary(Red) Document Service Platform',
                        url:'//red.library.sh.cn'
                    }
                    // ,
                    // {
                    //     name:'舆图',
                    //     id:'5',
                    //     hoverTit:'',
                    //     hoverEng:'',
                    //     url:'//gj.library.sh.cn/yutu'
                    // }
                ],
                swiperData2:[
                    {
                        name:'人物',
                        id:'1',
                        hoverTit:'人名规范库',
                        hoverEng:'Name Authority Database',
                        url:'//names.library.sh.cn'
                    },
                    {
                        name:'姓氏',
                        id:'2',
                        hoverTit:'华人姓氏列表',
                        hoverEng:'Chinese Surname List',
                        url:'//data.library.sh.cn/familynames'
                    },
                    {
                        name:'地名',
                        id:'3',
                        hoverTit:'地理名词表',
                        hoverEng:'Geographic Names List',
                        url:'//data.library.sh.cn/place/main'
                    },
                    {
                        name:'机构',
                        id:'4',
                        hoverTit:'收藏机构名录',
                        hoverEng:'Organizations Directory',
                        url:'//data.library.sh.cn/organization/main'
                    },
                    {
                        name:'时间',
                        id:'5',
                        hoverTit:'中国历史纪年表',
                        hoverEng:'Chinese History Chronology',
                        url:'//data.library.sh.cn/dynasty/main'
                    },
                    {
                        name:'事件',
                        id:'6',
                        hoverTit:'历史文化事件',
                        hoverEng:'Cultural Events',
                        url:'//data.library.sh.cn/shnh/event/webapi/tolist'
                    },
                    {
                        name:'印章',
                        id:'7',
                        hoverTit:'印章知识库',
                        hoverEng:'Seal Knowledge Base',
                        url:'//data.library.sh.cn/gj/webapi/toSealList'
                    },
                    {
                        name:'建筑',
                        id:'8',
                        hoverTit:'建筑',
                        hoverEng:'Architectures',
                        url:'//data.library.sh.cn/shnh/wkl/webapi/building/toAllBuilding'
                    },
                ],
                swiperData3:[
                    {
                        name:'CBDB',
                        id:'1',
                        hoverTit:'CBDB本体',
                        hoverEng:'CBDB Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/cbdb'
                    },
                    {
                        name:'电影',
                        id:'2',
                        hoverTit:'上海年华本体',
                        hoverEng:'Shanghai Memory Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlmemo'
                    },
                    {
                        name:'档案',
                        id:'3',
                        hoverTit:'手稿及档案本体',
                        hoverEng:'Archive and Manuscripts Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlmarc'
                    },
                    {
                        name:'家谱',
                        id:'4',
                        hoverTit:'家谱本体',
                        hoverEng:'Genealogy Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlgen'
                    },
                    {
                        name:'古籍',
                        id:'5',
                        hoverTit:'古籍本体',
                        hoverEng:'Ancient book Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlancient'
                    },
                    {
                        name:'书目',
                        id:'6',
                        hoverTit:'关联书目数据本体词表',
                        hoverEng:'Linked Bibliographic Data Ontology Vocabulary',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlbib'
                    }
                ],
                swiperData4:[
                    {
                        name:'众包',
                        id:'1',
                        hoverTit:'历史文献众包平台',
                        hoverEng:'Historical Document Crowd-sourcing Platform',
                        url:'http://zb.library.sh.cn/'
                    },
                   
                    {
                        name:'家谱联编',
                        id:'2',
                        hoverTit:'家谱联合编目系统',
                        hoverEng:'Chinese Genealogy Union Cataloging System',
                        url:'http://jplb.library.sh.cn/'
                    },
                    // {
                    //     name:'&nbsp;ETL',
                    //     id:'2',
                    //     hoverTit:'ETL（Any2RDF）',
                    //     hoverEng:'',
                    //     url:'http://data.library.sh.cn/mrdsj/index.html'
                    // }
                    {
                        name:'文本分析',
                        id:'3',
                        hoverTit:'文本分析工具包平台',
                        hoverEng:'',
                        url:'https://tools.library.sh.cn'
                    },
                    {
                        name:'HGIS平台',
                        id:'4',
                        hoverTit:'HGIS支撑平台',
                        hoverEng:'',
                        url:'https://hgis.library.sh.cn'
                    }
                    ,
                    {
                        name:'SNS平台',
                        id:'5',
                        hoverTit:'SNS分析平台',
                        hoverEng:'',
                        url:'https://sns.library.sh.cn'
                    }
                ],
                swiperData5:[
                    {
                        name:'报刊',
                        id:'1',
                        hoverTit:'近代报刊资源库',
                        hoverEng:'',
                        url:'https://dhc.library.sh.cn/bk/home'
                    },
                    {
                        name:'近代图书',
                        id:'2',
                        hoverTit:'中国近代图书全文数据库',
                        hoverEng:'Books of Modern China (1840~1949)',
                        url:'//jdts.library.sh.cn'
                    }
                ]
            }
        },
        created(){
            this.loggingStatus();
        },
        mounted() {
            this.$nextTick(()=>{
                this.searchAll();
                this.esc(this, 0); // 监听esc按键
            })
        },
        methods:{
            filterOption(input, option) { // 检索框提示配置
                let _text = option.componentOptions.children[0].text;
                if(this.isEmpty(_text)) return false;
                return (
                    _text.toUpperCase().indexOf(input.toUpperCase()) >= 0
                );
            },
            onAutoSearch(searchText){ // 检索补全
                console.log('onAutoSearch', searchText);
            },
            onFocus(){ // 检索框获得焦点/鼠标点入检索框
                if(this.activeUserInfo) this.getHisAndRetSearch(this);
            },
            getTabIndex(index){
                this.childTabIndex = index;
            },
            goDhcUc(){ // 登陆后,点击用户名跳转页面
                let token = this.getTokenFunc();  // 获取token
                // window.open("https://dhc.library.sh.cn/uc/?token=" + token);
                window.open("https://dhc.library.sh.cn/user?token=" + token);
            },
            navKnowledgeSearch(){ // 知识检索
                this.navKnowledgeFlag = true; // 知识检索按钮
                this.showSearch();
                this.navKnowledge = new Date().getTime();
            },
            showSearch(){ // 显示高级检索
                if(!this.navKnowledgeFlag) this.navAdvanced = new Date().getTime();
                this.navKnowledgeFlag = false;
                this.visible=true;
                this.tabContentIndex = 1;
                this.unScroll(); // 禁止滚动条滚动
                // 向父组件传值，弹出高级检索时，改变背景样式
                this.$emit('changeTab', this.tabContentIndex);
            },
            hideSearch(){ // 隐藏高级检索
                this.visible=false;
                this.tabContentIndex = 0;
                this.removeUnScroll(); // 移除禁止滚动条滚动
                // 向父组件传值，弹出高级检索时，改变背景样式
                this.$emit('changeTab', this.tabContentIndex);
            },
            changeInput(){
                if(this.searchType != 1) this.searchType = 1;
                this.filterParams = [{value: this.simpleKeyword}];
            },
            professSearch(){ // 其他页面专业检索跳转
                // 检索历史跳转
                let _historyParams = this.getUrlHistoryParams();
                if( !this.isEmptyObject(_historyParams) ){
                    this.getDhcCheckexp(_historyParams);
                    return;
                }

                let routeParams = this.$route.params;
                if( !this.isEmptyObject(routeParams) && !this.isEmpty(routeParams.professParams) ){
                    let _professParams = JSON.parse(decodeURIComponent(routeParams.professParams));
                    this.professSearch2(_professParams);
                }
            },
            professSearch2(data){ // 列表页-专业检索
                this.hideSearch(); // 隐藏高级检索
                this.simpleKeyword  = ''; // 清除简单检索条件
                // this.filterParams   = []; // 清除高级检索条件
                this.searchType     = data.searchType;
                this.professKeyword = data.expParams;
                this.filterParams   = [{value: this.professKeyword}];
                this.$emit('professSearch2', data);
            },
            advancedSearch(){ // 其他页面高级检索跳转
                // 检索历史跳转
                let _historyParams = this.getUrlHistoryParams();
                if( !this.isEmptyObject(_historyParams) ){
                    let _advParams = {
                        searchType   : _historyParams.searchType,
                        DT           : _historyParams.DT,
                        filters      : _historyParams.cdtn,
                        finalStaticDT: [ 'BK', 'JP', 'GJ', 'SD', 'JDTS', 'HSWX']
                    }
                    this.advancedSearch2(_advParams);
                    return;
                }

                let routeParams = this.$route.params;
                if( !this.isEmptyObject(routeParams) && !this.isEmpty(routeParams.advParams) ){
                    let _advParams = JSON.parse(decodeURIComponent(routeParams.advParams));
                    this.advancedSearch2(_advParams);
                }
            },
            advancedSearch2(data){ // 列表页-文献检索
                this.hideSearch(); // 隐藏高级检索
                this.simpleKeyword  = ''; // 清除简单检索条件
                this.professKeyword = ''; // 清除专业检索条件
                this.advancedParams = data;
                this.searchType     = this.advancedParams.searchType;
                this.filterParams   = this.advancedParams.filters;
                if(this.isEmptyArray(this.advancedParams.DT)) this.filterParams = [];
                this.$emit('advancedSearch2', this.advancedParams);
            },
            getSimpleFreetext(){ // 获取地址栏简单检索参数
                if(this.isResultSearch) this.simpleKeyword = this.getZhUrlParam('freetext');
                if(this.isEmpty(this.simpleKeyword)) {
                    let params = this.$route.params;
                    if(!this.isEmptyObject(params) && !this.isEmpty(params.simpleKeyword)){
                        this.simpleKeyword  = params.simpleKeyword;
                    }
                }
                if( !this.isEmpty(this.simpleKeyword) ) this.filterParams = [{value: this.simpleKeyword}];
            },
            simpleSearch(){ // 其他页面简单检索跳转
                this.hideSearch(); // 隐藏高级检索框
                this.getSimpleFreetext(); // 获取参数值
                this.searchType = 1;
                this.professKeyword = ''; // 专业检索清空
                // this.filterParams   = []; // 清除高级检索条件
                
                let simpleParams = {
                    searchType: this.searchType, 
                    simpleKeyword: this.simpleKeyword
                }
                // 检索历史跳转
                let _historyParams = this.getUrlHistoryParams();
                if( !this.isEmptyObject(_historyParams) ) simpleParams.simpleKeyword = _historyParams.freetext;
                this.$emit('simpleSearch2', simpleParams);
            },
            simpleSearch2(){ // 列表页简单检索
                this.hideSearch(); // 隐藏高级检索框
                this.searchType = 1;
                this.professKeyword = ''; // 专业检索清空
                this.filterParams = [{value: this.simpleKeyword}];
                // this.filterParams   = []; // 清除高级检索条件

                let simpleParams = {
                    searchType: this.searchType, 
                    simpleKeyword: this.simpleKeyword
                }
                if(this.isResultSearch) this.$emit('simpleSearch2', simpleParams); // 列表页(result) 检索
                else this.$router.push({ name:"searchResult",  params: simpleParams }); // 其他页面跳转检索
            },
            getUrlHistoryParams(){ // 获取地址栏历史检索参数
                let _historyParams = this.getZhUrlParam('historyParams');
                // this.searchType = _historyParams.searchType;
                if(_historyParams && !this.isEmpty(_historyParams)) {
                    let _hisParams = JSON.parse(decodeURIComponent(_historyParams));
                    switch ( Number(_hisParams.searchType) ) { // 筛选栏参数显示
                        case 1:
                            this.simpleKeyword  = _hisParams.freetext;
                            this.filterParams   = [{value: this.simpleKeyword}];
                            break;
                        case 2:
                            this.filterParams   = _hisParams.cdtn;
                            break;
                        case 3:
                            this.professKeyword = _hisParams.expression;
                            this.filterParams   = [{value: this.professKeyword}];
                            break;
                        default:
                            break;
                    }
                    return _hisParams
                };
                return null;
            },
            getResultSearchData(){
                return this.$qs.parse(unescape(localStorage.resultSearchData));
            },
            knowledgeChange(data){ // 列表页知识检索
                this.simpleKeyword = data.simpleKeyword;
                this.simpleSearch2();
            },
            showSlide(){
                this.slideShow=!this.slideShow
                this.$emit('hideContent')
            },
            removeFilter(index){ // 检索条件筛选
                // 删除高级检索筛选条件
                this.filterParams.splice(index, 1);
                if(this.searchType == 2 && !this.isEmptyArray(this.filterParams)) { // 高级检索
                    this.advancedParams.filters = this.filterParams;
                    this.$emit('advancedSearch2', this.advancedParams);
                    return;
                }
                this.simpleKeyword  = '';
                this.professKeyword = '';
                this.simpleSearch2(); // 简单检索
            },
            getSearchType(){ // 获取 searchType  1：简单检索，2：高级检索，3：专业检索
                let searchType = 1;
                let params = this.$route.params;
                if( !this.isEmptyObject(params) && !this.isEmpty(params.searchType) ){
                    searchType = Number(params.searchType);
                }
                // let _resultSearchData = this.getResultSearchData();
                // if(!this.isEmptyObject(_resultSearchData)) searchType = Number(_resultSearchData.searchType);
                return searchType;
            },
            searchAll(){
                // 检索开始
                this.startTime = new Date().getTime();  // 开始时间
                let _historyParams = this.getUrlHistoryParams();
                if( this.isEmptyObject(_historyParams) ) this.searchType = this.getSearchType();
                else this.searchType = Number(_historyParams.searchType);
                switch (this.searchType) {
                    case 1: // 简单检索
                        this.simpleSearch();
                        break;
                    case 2: // 高级检索
                        this.advancedSearch();
                        break;
                    case 3: // 专业检索
                        this.professSearch();
                        break;
                    default:
                        break;
                }
            },
            logo(){
                this.$router.push('/');
            },
            login(){ // 登录
                this.goLogin(this.Common.authorizeUrl);
            },
            exit(){
                this.isExit();
            },
            loggingStatus(){ // 登录状态
                let token = this.getTokenFunc();  // 获取token
                this.getAccount(token); // 获取用户信息
            },
            toFullTitle(str){ // 全称
                let obj = {
                    "TI" : "题名",
                    "CO" : "责任者",
                    "ED" : "版本",
                    "HO" : "馆藏",
                    "IS" : "出版时间"
                }
                return obj[str];
            },
            handleHover(e,item){
                this.showHover = true
                this.hoverTit = item.hoverTit
                this.hoverEng = item.hoverEng
                this.hoverX = e.clientX-100
                this.hoverY = e.clientY+40
            },
            handleLeave(){
                this.showHover = false
            },
            getDhcCheckexp: async function(_historyParams){
                let expParams = {
                    'exp': _historyParams.expression
                }
                await this.$axios.post(this.Common.getDhcCheckexpUrl, expParams)
                .then((res) => {
                    let resultData  = res.data;
                    if(resultData.errorCode == 0){
                        let professParams = {
                            searchType: _historyParams.searchType,
                            datas     : resultData.datas, 
                            expParams : _historyParams.expression
                        }
                        this.professSearch2(professParams);
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
            }
        },
        destroyed(){ // 销毁
            // window.removeEventListener('popstate', this.goBack, false);
        },
    }
</script>

<style>
/* 输入框自动完成功能 */
.ant-select-dropdown{
    width: 30rem!important;
    max-width: 700px!important;
    background-color: rgba(255, 255, 255, 0.9)!important;
}

.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){
    /* 鼠标悬浮背景色 */
    background-color: rgba(201, 201, 201, 0.3)!important;
}
.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled){
    /* 鼠标悬浮相同的内容背景色 */
    background-color: rgba(201, 201, 201, 0.3)!important;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group-title {
  color: #666;
  font-weight: bold;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group {
  border-bottom: 1px solid #f6f6f6;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item {
  padding-left: 16px;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item.show-all {
  text-align: center;
  cursor: default;
}

.certain-category-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
</style>

<style scoped>
/* 输入框自动完成功能 */
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix {
  right: 12px;
}
.certain-category-search-wrapper >>> .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-focused
  .certain-category-icon {
  color: #108ee9;
}
.certain-category-search-wrapper >>> .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}
</style>

<style scoped lang="less">
    /deep/.ant-select-selection{
        background-color: initial;
    }
    /deep/.ant-select{
        flex-grow: 1;
    }
    .result-page-nav{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 10;
        .logo{
            margin: 20px;
            width: auto;
            height: 40px;
            cursor: pointer;
            @media(min-width: 1100px){
                height: 50px;
            }
            @media(min-width: 1400px){
                height: 68px;
            }
        }
        .result-sch{
            flex-grow: 1;
            margin: 40px 10px 0 10px;
            align-self: flex-start;
            max-width: 700px;
            &.cur{
                display: none;
            }
            .tab-content{
                transition: opacity 0.5s;
                .close{
                    position: absolute;
                    width: 30px;
                    height: 30px;
                    top: 15px;
                    right: 15px;
                    &:after{
                        position: absolute;
                        width: 16px;
                        height: 16px;
                        top: 7px;
                        right: 7px;
                        content: "";
                        background: url("../../assets/images/close.png");
                    }
                }
            }
            .ipt-box{
                width: 95%;
                height: 30px;
                border-radius: 15px;
                background: #2e3f7a;
                display: flex;
                align-items: center;
                position: relative;
                input{
                    flex-grow: 1;
                    height: 30px;
                    padding-left: 15px;
                    color: #fff;
                }
                .advanced-search{
                    position: absolute;
                    right: -26px;
                    font-size: 11px;
                    a{
                        color: #fff;
                    }
                }
            }
            .filters{
                color: #fff;
                margin-top: 15px;
                font-size: 12px;
                padding-left: 20px;
                display: flex;
                justify-content: flex-start;
                align-self: center;
                line-height: 24px;
                &.cur{ // 20200911
                    opacity: 0;
                }
                span{
                    background: #2e3e7a;
                    padding: 0 10px;
                    line-height: 24px;
                    border-radius: 12px;
                    margin-right: 10px;
                    transition: all .5s;
                    &.hide{
                        transform: translate(-10px,0);
                        opacity: 0;
                    }
                    &.spanCur{
                        display: none;
                    }
                }
            }
        }
        .navs{
            text-align: right;
            line-height: 34px;
            position: relative;
            z-index: 9;
            &.hd{
                .nv{
                    display: none;
                }
            }
            .nv{
                color: #f0be73;
                font-size: 15px;
                display: inline-block;
                margin: 0 10px;
                vertical-align: top;
                @media(min-width: 1400px){
                    margin: 0 18px;
                }
                a{
                    color: #f0be73;
                }
                &:hover{
                    opacity: .9;
                }
                .user{
                    width: 36px;
                    vertical-align: top;
                    margin-right: 5px;
                }
            }
            .menu-toggle{
                display: inline-block;
                margin: 0 18px;
                width: 50px;
                height: 34px;
                vertical-align: top;

                span{
                    display: block;
                    margin: 4px 0 10px 0;
                    height: 2px;
                    width: 100%;
                    background: #f0be73;
                    transition: transform .5s,color .5s;
                }
                &.cur{
                    span{
                        background: #f0be73;
                        &:nth-child(1){
                            transform: translate(0,12px);
                        }
                        &:nth-child(3){
                            transform: translate(0,-12px);
                        }
                    }
                }
            }
        }
    }
</style>
